module.exports = __webpack_public_path__ + "img/russische-kipburger-ingredienten.adc9750f.jpg";